module.exports = __webpack_public_path__ + "img/v7.4bbedecd.jpg";